import Vue from 'vue'

export const DocumentsService = {
  list (params = []) {
    return Vue.axios.get('/attachmentdocuments', { params })
      .then((response) => response.data)
  },

  approve (id) {
    return Vue.axios.post(`attachmentdocuments/${id}/approve`)
      .then((response) => response.data)
  }
}
